import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import './Hero.scss';

export default function Hero() {
  const { t } = useI18n();
  return (
    <section className="sora2-hero">
      <div className="sora2-hero__content">
        <h1 className="sora2-hero__title">{t('videoGeneration.sora.hero.title')}</h1>
        <p className="sora2-hero__tags">{t('videoGeneration.sora.hero.tags')}</p>
        <p className="sora2-hero__desc">{t('videoGeneration.sora.hero.desc')}</p>
      </div>
    </section>
  );
}